// extracted by mini-css-extract-plugin
export var authors = "TutorialModal-module--authors--719fe";
export var carouselBtn = "TutorialModal-module--carouselBtn--d45d5";
export var carouselNav = "TutorialModal-module--carouselNav--9b26d";
export var carouselWrapper = "TutorialModal-module--carouselWrapper--67a3f";
export var category = "TutorialModal-module--category--cdb19";
export var contentWrapper = "TutorialModal-module--contentWrapper--a4b73";
export var copyButton = "TutorialModal-module--copyButton--b159b";
export var date = "TutorialModal-module--date--daeb9";
export var description = "TutorialModal-module--description--664aa";
export var duration = "TutorialModal-module--duration--26a0c";
export var emailForm = "TutorialModal-module--emailForm--ab429";
export var emailInput = "TutorialModal-module--emailInput--1ae9b";
export var errorMessage = "TutorialModal-module--errorMessage--73726";
export var gatingContent = "TutorialModal-module--gatingContent--d9c67";
export var gatingDescription = "TutorialModal-module--gatingDescription--a574b";
export var gatingTitle = "TutorialModal-module--gatingTitle--8bc36";
export var gatingWrapper = "TutorialModal-module--gatingWrapper--66e73";
export var infoSection = "TutorialModal-module--infoSection--db134";
export var loadingWrapper = "TutorialModal-module--loadingWrapper--4fb91";
export var lockIcon = "TutorialModal-module--lockIcon--19ff2";
export var mainContent = "TutorialModal-module--mainContent--f723c";
export var meta = "TutorialModal-module--meta--e48fb";
export var nameRow = "TutorialModal-module--nameRow--70c49";
export var previewImage = "TutorialModal-module--previewImage--15b7c";
export var previewOverlay = "TutorialModal-module--previewOverlay--67559";
export var previewPlaceholder = "TutorialModal-module--previewPlaceholder--5ed4a";
export var previewThumbnail = "TutorialModal-module--previewThumbnail--e27fe";
export var previewTitle = "TutorialModal-module--previewTitle--d3334";
export var previewWrapper = "TutorialModal-module--previewWrapper--2243f";
export var relatedCard = "TutorialModal-module--relatedCard--9ae7a";
export var relatedCategory = "TutorialModal-module--relatedCategory--8bbbd";
export var relatedDuration = "TutorialModal-module--relatedDuration--dcfb5";
export var relatedGrid = "TutorialModal-module--relatedGrid--bb064";
export var relatedHeader = "TutorialModal-module--relatedHeader--6b6a0";
export var relatedHeading = "TutorialModal-module--relatedHeading--db9ae";
export var relatedInfo = "TutorialModal-module--relatedInfo--33ddb";
export var relatedPlaceholder = "TutorialModal-module--relatedPlaceholder--cfc36";
export var relatedSection = "TutorialModal-module--relatedSection--9ed50";
export var relatedThumbnail = "TutorialModal-module--relatedThumbnail--46258";
export var relatedTitle = "TutorialModal-module--relatedTitle--05dab";
export var title = "TutorialModal-module--title--0af9a";
export var video = "TutorialModal-module--video--35908";
export var videoWrapper = "TutorialModal-module--videoWrapper--53133";